import { config, handleResponse } from '../../_helpers';

export const overrideChargeServices = {    
    getWayBillRefOverRide,
    getOverRideCode,
    getOverRideList,

    createOverRide,

    updateOverRideId,
    updateOverRideIdStatus,

    deleteOverRideId,  
}
function createOverRide(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/WayBillOverRideCharges/createOverRide/${payload.wayBillRef}`, requestOptions).then(handleResponse);   
}

function updateOverRideIdStatus(payload) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/WayBillOverRideCharges/updateOverRideIdStatus`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/WayBillOverRideCharges/updateOverRideIdStatusV1`, requestOptions).then(handleResponse);
}

function updateOverRideId(payload, id) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/WayBillOverRideCharges/updateOverRideId/${id}`, requestOptions).then(handleResponse);
}

function deleteOverRideId(payload) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/WayBillOverRideCharges/deleteOverRideId`, requestOptions).then(handleResponse);
}

function getWayBillRefOverRide(wb) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/WayBillOverRideCharges/getWayBillRefOverRide/${wb}`, requestOptions).then(handleResponse);
}

function getOverRideList(userId, isApprover, status, skip, take, search) {
    const requestOptions = {
        method: 'GET'
    };
    if (search) {
        return fetch(`${config.apiUrl}/WayBillOverRideCharges/getOverRideList?UserId=${userId}&status=${status}&isApprover=${isApprover}&skip=${skip}&take=${take}&search=${search}`, requestOptions).then(handleResponse);
    }
    else {
        return fetch(`${config.apiUrl}/WayBillOverRideCharges/getOverRideList?UserId=${userId}&status=${status}&isApprover=${isApprover}&skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }
}

function getOverRideCode(id) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/WayBillOverRideCharges/getOverRideCode/${id}`, requestOptions).then(handleResponse);
}